import React from 'react';

import { getShortDomainName, getInfoEmailAddress } from '../../../utils/domain-utils';

const ContactsInfo = () => {
  const domainName = getShortDomainName();
  const emailAddress = getInfoEmailAddress();

  return (
    <>
      {domainName === 'pro' && (
        <p className="tutorium-text">
          {'tel: '}
          <a href="tel:+447460143813" className="tutorium-footer-link">
            +44 746 014 38 13
          </a>
        </p>
      )}
      <p className="tutorium-text">
        {'email: '}
        <a href={`mailto:${emailAddress}`} className="tutorium-footer-link">
          {emailAddress}
        </a>
      </p>
      <p className="tutorium-text">
        {'web: '}
        <a href={`http://www.tutorium.${domainName}`} className="tutorium-footer-link">
          http://www.tutorium.{domainName}
        </a>
      </p>
    </>
  );
};

export default ContactsInfo;
